import { publicCatalogClient } from '../publicCatalogService';


const API_URL = 'category-public/';

export interface ApiCategory {
    id: number;
    slug: string;
    nombre: string;
    descripcion: string;
    imagen: string | null;
    estado: boolean;
    fecha_creacion: string;
}

// Obtener SOLO categorías activas
export const fetchActiveCategories = async (): Promise<ApiCategory[]> => {
    return (await publicCatalogClient.get<ApiCategory[]>(API_URL)).data;
};
